import { render, staticRenderFns } from "./SharedDeadlines.vue?vue&type=template&id=5df4f51b&scoped=true&"
import script from "./SharedDeadlines.vue?vue&type=script&lang=js&"
export * from "./SharedDeadlines.vue?vue&type=script&lang=js&"
import style0 from "./SharedDeadlines.vue?vue&type=style&index=0&id=5df4f51b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df4f51b",
  null
  
)

export default component.exports